import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError, map, take } from 'rxjs/operators';

import { HrService } from '@app/hr/hr.service';
import { LoginService } from '@app/common/login.service';
import { AlertService } from '@app/shared/alert.service';
import { hrIsAdmin } from '@app/shared/_models/hr';

// Confort d'écran : habilitations lues en base (GET /users, repli sur le jeton) ; le serveur décide (habilitation en base + mot de passe à chaque requête).
export const adminGuard: CanActivateFn = (): Observable<boolean> => {
  const loginService = inject(LoginService);
  const hrService = inject(HrService);
  const alertService = inject(AlertService);
  const router = inject(Router);

  // Non connecté : AuthGuard, posé avant, renvoie déjà vers /login.
  if (!loginService.loggeduser) return of(false);
  return hrService.getUsers$().pipe(
    take(1),
    catchError(() => of([])),
    map(users => {
      if (hrIsAdmin(loginService.loggeduser, users)) return true;
      alertService.error('Réservé aux administrateurs.');
      router.navigate(['/home']);
      return false;
    }),
  );
};
